<template>
  <el-dialog
    append-to-body
    :visible.sync="show_roata_dialog"
    width="100%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <template #title>
      <div style="text-align: center">
        Observatie: {{ observatie }}
      </div>
    </template>
    <div style="font-size: 12px; text-align: center">
      <span >
        Click pe roata pentru a pune cantitatea
      </span>
    </div>
    <div class="masina">
      <div class="masina-content">
        <div class="left">
          <!-- Roata #1 -->
          <div class="roata-left">
            <el-input
              v-if="roti[0].selected"
              v-model="roti[0].qty"
              placeholder="Cantitate"
              type="number"
              :clearable="!acceptaCantitate"
              :min="0"
              :max="!acceptaCantitate ? 1 : cantitateMaxima"
              @clear="roti[0].qty = 0"
              style="margin-top: 10px; display: block !important"
            />
            <img
              @click="select_roata(0)"
              src="../../assets/roata.svg"
              alt="roata"
            />
          </div>
          <div class="inputs"></div>

          <!-- Roata #2 -->
          <div class="roata-left">
            <div class="inputs">
              <el-input
                v-if="roti[1].selected"
                v-model="roti[1].qty"
                placeholder="Cantitate"
                type="number"
                :clearable="!acceptaCantitate"
                :min="0"
                :max="!acceptaCantitate ? 1 : cantitateMaxima"
                @clear="roti[1].qty = 0"
                style="margin-top: 10px; display: block !important"
              />
              <img
                @click="select_roata(1)"
                src="../../assets/roata.svg"
                alt="roata"
              />
            </div>
          </div>
        </div>

        <div class="center">
          <img src="../../assets/m.svg" alt="masina" />
        </div>

        <div class="right">
          <!-- Roata #3 -->
          <div class="roata-right">
            <div class="inputs">
              <img
                @click="select_roata(2)"
                src="../../assets/roata.svg"
                alt="roata"
              />
              <el-input
                v-if="roti[2].selected"
                v-model="roti[2].qty"
                placeholder="Cantitate"
                type="number"
                :clearable="!acceptaCantitate"
                :min="0"
                :max="!acceptaCantitate ? 1 : cantitateMaxima"
                @clear="roti[2].qty = 0"
                style="margin-top: 10px; display: block !important"
              />
            </div>
          </div>

          <!-- Roata #4 -->
          <div class="roata-right">
            <div class="inputs">
              <img
                @click="select_roata(3)"
                src="../../assets/roata.svg"
                alt="roata"
              />
              <el-input
                v-if="roti[3].selected"
                v-model="roti[3].qty"
                placeholder="Cantitate"
                type="number"
                :clearable="!acceptaCantitate"
                :min="0"
                :max="!acceptaCantitate ? 1 : cantitateMaxima"
                @clear="roti[3].qty = 0"
                style="margin-top: 10px; display: block !important"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="below">
        <div v-if="cantitate > 4" class="roata">
          <div class="inputs-below">
            <img
              @click="select_roata(4)"
              src="../../assets/roata.svg"
              alt="roata"
            />
            <el-input
              v-if="roti[4].selected"
              v-model="roti[4].qty"
              placeholder="Cantitate"
              type="number"
              :clearable="!acceptaCantitate"
              :min="0"
              :max="!acceptaCantitate ? 1 : cantitateMaxima"
              @clear="roti[4].qty = 0"
              style="margin-top: 10px; display: block !important"
            />
          </div>
        </div>
        <div v-if="cantitate > 5" class="roata">
          <div class="inputs-below">
            <img
              @click="select_roata(5)"
              src="../../assets/roata.svg"
              alt="roata"
            />
            <el-input
              v-if="roti[5].selected"
              v-model="roti[5].qty"
              placeholder="Cantitate"
              type="number"
              :clearable="!acceptaCantitate"
              :min="0"
              :max="!acceptaCantitate ? 1 : cantitateMaxima"
              @clear="roti[5].qty = 0"
              style="margin-top: 10px; display: block !important"
            />
          </div>
        </div>
        <div v-if="cantitate > 6" class="roata">
          <div class="inputs-below">
            <img
              @click="select_roata(6)"
              src="../../assets/roata.svg"
              alt="roata"
            />
            <el-input
              v-if="roti[6].selected"
              v-model="roti[6].qty"
              placeholder="Cantitate"
              type="number"
              :clearable="!acceptaCantitate"
              :min="0"
              :max="!acceptaCantitate ? 1 : cantitateMaxima"
              @clear="roti[6].qty = 0"
              style="margin-top: 10px; display: block !important"
            />
          </div>
        </div>
        <div v-if="cantitate > 7" class="roata">
          <div class="inputs-below">
            <img
              @click="select_roata(7)"
              src="../../assets/roata.svg"
              alt="roata"
            />
            <el-input
              v-if="roti[7].selected"
              v-model="roti[7].qty"
              placeholder="Cantitate"
              type="number"
              :clearable="!acceptaCantitate"
              :min="0"
              :max="!acceptaCantitate ? 1 : cantitateMaxima"
              @clear="roti[7].qty = 0"
              style="margin-top: 10px; display: block !important"
            />
          </div>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <!-- <el-button @click="cancel()">Renunta</el-button> -->
      <el-button type="primary" @click="save()">Salveaza</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "Observatii_devize_dialog",

  data() {
    return {
      show_roata_dialog: false,
      temp_roata: {
        index: 0,
        object: {
          deformari_jante: "Redus",
          starea_jantei: "Proasta",
        },
      },
      roti: Array.from({ length: 8 }, (_, index) => ({
        index,
        qty: "",
        selected: false,
      })),
      observatie: "",
      cantitate: 0,
      acceptaCantitate: false,
      cantitateMaxima: 0,
    };
  },
  methods: {
    show_me(obs, cantitate, acceptaCantitate, cantitateMaxima) {
      this.show_roata_dialog = true;
      this.cantitate = cantitate;
      this.observatie = obs;
      this.acceptaCantitate = acceptaCantitate;
      this.cantitateMaxima = cantitateMaxima;
      if(cantitateMaxima == 0 || !cantitateMaxima){
        this.cantitateMaxima = 99999;
      }

      this.roti = Array.from({ length: 8 }, (_, index) => ({
        index,
        qty: "",
        selected: false,
      }));
    },

    select_roata(index) {
      const roata = this.roti[index];
      roata.selected = !roata.selected;
      if (!roata.selected) {
        roata.qty = "";
      }else{
        roata.qty = "1";
      }
    },

    save() {
      const rotiCuObservatie = {
        observatiePredefinita: this.observatie,
        roti: this.roti.filter((roata) => roata.selected),
      };
      // console.log("rotiCuObservatie", rotiCuObservatie);
      this.$emit("saveObsDialog", rotiCuObservatie);
      this.show_roata_dialog = false;
    },
    cancel() {
      this.show_roata_dialog = false;
      this.$emit("closeObsDialog", {
        observatiePredefinita: this.observatie,
      });
    },
  },
};
</script>

<style scoped>
.masina {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  margin-top: 50px;
}

.masina-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.below {
  margin-top: 20px;
  display: flex;
  gap: 80px;
}

.inputs-below {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 15px;
  margin-top: 10px;
}

@media (max-width: 768px) {
  .below {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .inputs-below {
    flex-direction: row;
    gap: 15px;
  }
}

.left,
.right {
  padding: 15px 0;
  height: 400px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 15px;
}

.roata {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  cursor: pointer;
}

.roata-left {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
  cursor: pointer;
}

.roata-right {
  display: flex;
  justify-content: flex-right;
  align-items: center;
  gap: 15px;
  cursor: pointer;
}

.chestionar {
  width: 350px;
  height: 200px;
  padding: 10px;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
  border-radius: 5px;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.457);
}

.chestionar p {
  font-weight: 600;
}

/* Imaginile */
img {
  width: 70px;
  height: 70px;
}

/* Centru */
.center {
  display: flex;
  justify-content: center;
}

.center img {
  width: 150px;
  height: 200px;
}

.inputs {
  display: flex;
  gap: 12px;
}
</style>
